/**
 * @fileoverview Welcome page component for the first step of the Listings Launch flow.
 *
 * @author Sravan Parimi (sparimi@yext.com)
 */
import {LISTINGS_ASSET} from '/ui/components/marketingactivationpage/images/listings';
import {MarketingActivationPage} from '/ui/components/marketingactivationpage/marketingactivationpage';

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/welcome.module.scss';

/**
 * @returns {React.ReactNode}
 */
function Description() {
  return (
    <div>
      {yext.msg('All existing entities are already set up.')}
    </div>
  );
}

/**
 * @returns {React.ReactNode}
 */
export function Welcome() {
  return (
    <div className={styles.container}>
      <div className={styles.welcome}>
        <MarketingActivationPage
          image={LISTINGS_ASSET}
          header={yext.msg('Welcome!')}
          description={<Description />}>
        </MarketingActivationPage>
      </div>
    </div>
  );
}
